import Phaser from "phaser";
import { Panel } from "../ui/Panel";
import { RunState } from "../state/runState";
import { LAYOUT, TEXT_STYLES } from "../constants";
import { tagTextForAutomation } from "../automation/automationTags";
import { getPerkName } from "../data/cards";
import { SKILLS } from "../data/skills";

export const formatRunInfo = (run: RunState): string => {
  const skills = Object.entries(run.player.skills)
    .map(([skillId, level]) => `${SKILLS[skillId as keyof typeof SKILLS].name} Lv${level}`)
    .join(", ");
  const perks = run.player.perks.length
    ? run.player.perks.map((perkId) => getPerkName(perkId)).join(", ")
    : "None";

  // Add floor theme name if available
  const floorTheme = run.currentFloorConfig?.name ? ` — ${run.currentFloorConfig.name}` : "";
  const floorLine = `Floor: ${run.floor}${floorTheme}`;

  // Add encounter counts if available
  const totalEncounters = run.encountersCleared + run.encountersRemaining;
  const encounterLine =
    totalEncounters > 0 ? `Encounters: ${run.encountersCleared}/${totalEncounters}` : "";

  const lines = [
    floorLine,
    encounterLine,
    `HP: ${run.player.hp}/${run.player.maxHp}`,
    `ATK: ${run.player.atk}`,
    `Skills: ${skills}`,
    `Perks: ${perks}`,
  ].filter(Boolean);

  return lines.join("\n");
};

export const createRunInfoPanel = (
  scene: Phaser.Scene,
  run: RunState,
  x: number,
  y: number,
  width: number
): Panel => {
  const panel = new Panel(scene, x, y, width, 200, "Run Info");
  const text = scene.add
    .text(LAYOUT.panelPadding, 40, formatRunInfo(run), TEXT_STYLES.body)
    .setOrigin(0, 0);
  panel.add(text);
  tagTextForAutomation(text, "run-info");
  return panel;
};
